import * as React from 'react';

interface SearchBarProps {
    onSearch: (searchValue: string) => void;
    localizedPlaceholder?: string;
    clearSearchAfterSubmit?: boolean;
}

export class SearchBar extends React.PureComponent<SearchBarProps> {
    public render() {
        return (
            <div className="input-group">
                <input id="search-text-input" onKeyDown={this.searchInput_keyDown} type="text" className="form-control" placeholder={this.props.localizedPlaceholder ?? ""} />
                <span className="input-group-btn">
                    <button id="initiate-search-button" className="btn btn-default" type="button" onClick={e => this.addSearchValue()}><span className="glyphicon glyphicon-search" aria-hidden="true"></span></button>
                </span>
            </div>  
        );
    }

    // ===============================================================================

    private addSearchValue = () => {
        const $searchInput = $("#search-text-input") as JQuery<HTMLInputElement>;
        const searchVal = $searchInput.val()?.toString().trim() ?? "";

        if (searchVal === "") {
            return;
        }

        this.props.onSearch(searchVal);

        if (this.props.clearSearchAfterSubmit) {
            $searchInput.val("");
        }
    }

    // ===============================================================================
    //
    // UI Events
    //

    private searchInput_keyDown = (e: React.KeyboardEvent) => {
        if (e.key !== "Enter") {
            return;
        }

        this.addSearchValue();
    }
}